import { RXJSDBService } from '@cmx/shared/data-access/rxdb';
import { lastValueFrom } from 'rxjs';

export function createDBFactory(rxjsdbService: RXJSDBService) {
  return async () => {
    return await lastValueFrom(rxjsdbService.createDB());
  };
}
